/* eslint-disable no-plusplus */
/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import { getUserAgentId } from '../../shared/helper-utils/localStorage';
import {
  getCabinBaggage,
  getSupplierName,
  isEmpty,
  showSupplier,
} from '../../shared/helper-utils/appUtils';

import AppLink from '../../shared/components/app-link/AppLink';
import AppCheckBox from '../../shared/components/app-check-box/AppCheckBox';
import { getBrandedFaresApi } from '../../api/flightApi';
import AppModal from '../../shared/components/app-modal/AppModal';
import ResultCardFlightInfo from '../roundt-trip-intl/ResultCardFlightInfo';
import FareCard, {
  getSeatsLeftText,
} from '../../shared/components/fare-card/FareCard';
import FareBreakup from '../../shared/components/fare-card/FareBreakup';

export default function OneWayFareComponent({
  fare,
  userSelectedFare,
  setUserSelectedFare,
  fareInclusions,
  searchRequest,
  showInvoiceFare,
  handleFareRulesClick,
  flight,
  handleShowMiniFareRules,
  handleBook,
  handleSelectForEmail,
  isFareSelectedForEmail,
  setIsLoading,
  journeyType,
  domint,
  returnFlight,
  isAmPmFormat,
  isRtIntl = false,
}) {
  const [showBrandedfares, setShowBrandedfares] = useState(false);
  const [brandedFares, setBrandedFares] = useState([]);
  const getWaterMarkForFare = () => {
    let watermark = '';
    for (let i = 0; i < 100; i++) {
      watermark += `${getUserAgentId()} `;
    }
    return watermark;
  };

  const handleShowBrandedFares = async () => {
    if (brandedFares.length === 0) {
      setIsLoading(true);
      const res = await getBrandedFaresApi(
        searchRequest,
        fare.nextraflightkey,
        getUserAgentId(),
        journeyType,
        domint,
      );
      if (
        res &&
        res.flightjourneys[0] !== '' &&
        res.flightjourneys[0] !== undefined
      ) {
        const flightOptions = Array.isArray(res.flightjourneys[0].flightoptions)
          ? res.flightjourneys[0].flightoptions
          : [res.flightjourneys[0].flightoptions];
        flightOptions.sort(
          (flightOption1, flightOption2) =>
            flightOption1.recommendedflight[0].flightfare.totalfq -
            flightOption2.recommendedflight[0].flightfare.totalfq,
        );
        const list = [];
        flightOptions.forEach((fo) => {
          const carrierList = [];
          const seatsList = [];
          const bagList = [];
          const weighlist = [];
          const cabinBagWeightList = [];
          const cabinBagUnitList = [];
          const bookingClassList = [];
          const airFreeTextList = [];
          const returnBookingClassList = [];
          const returnWeightList = [];
          const returnUnitList = [];
          const returnSeatsList = [];
          const returnCarrierList = [];
          fo.recommendedflight[0].flightlegs.forEach((leg) => {
            carrierList.push(leg.carrier);
            seatsList.push(leg.numseatsavailable);
            bagList.push(leg.bagweight);
            weighlist.push(leg.bagunit);
            cabinBagWeightList.push(leg.cabinBagweight);
            cabinBagUnitList.push(leg.cabinBagunit);
            bookingClassList.push(leg.bookingclass);
            if (leg.weather_origin !== '') {
              airFreeTextList.push(leg.weather_origin);
            }
          });
          const fr = fo.recommendedflight[0].flightfare;
          let supplierName = fo.recommendedflight[0].supplier;
          if (isEmpty(supplierName)) {
            const isAmadeus = fo.recommendedflight[0].nextracustomstr
              .split(',')
              .some((word) => word.includes('AMADEUS'));
            if (isAmadeus) {
              supplierName = 'amadeus';
            }
          }
          if (isRtIntl) {
            fo.recommendedflight[1].flightlegs.forEach((leg) => {
              returnCarrierList.push(leg.carrier);
              returnUnitList.push(leg.bagunit);
              returnWeightList.push(leg.bagweight);
              returnSeatsList.push(leg.numseatsavailable);
              returnBookingClassList.push(leg.bookingclass);
            });
          }

          fr.supplierName = supplierName;
          fr.nextraflightkey = fo.recommendedflight[0].nextraflightkey;
          fr.nextracustomstr = fo.recommendedflight[0].nextracustomstr;
          fr.isminifarerulesrequired =
            fo.recommendedflight[0].isminifarerulesrequired;
          fr.airFreeText = airFreeTextList;
          fr.flightCarrier = carrierList;
          fr.numseatsavailable = seatsList;
          fr.flightBagWeight = bagList;
          fr.flightBagUnit = weighlist;
          fr.cabinBagweight = cabinBagWeightList;
          fr.cabinBagunit = cabinBagUnitList;
          fr.bookingClass = bookingClassList;
          fr.flightCarrierReturn = returnCarrierList;
          fr.flightBagWeightReturn = returnWeightList;
          fr.flightBagUnitReturn = returnUnitList;
          fr.returnNumseatsavailable = returnSeatsList;
          fr.returnBookingClass = returnBookingClassList;
          fr.isBrandedFare = true;
          list.push(fr);
        });
        setBrandedFares(list);
      }
      setIsLoading(false);
    }
    setShowBrandedfares(!showBrandedfares);
  };
  const isGatewayFlight =
    flight?.nextracustomstr?.includes('iweenflightgateway');
  const carrierInclusion = fareInclusions?.[fare.flightCarrier?.[0]];
  const fareTypeInclusion = isGatewayFlight
    ? null
    : fareInclusions?.[fare.faretype];
  const isSeatCountHidden =
    fare.supplierName === 'airarabia' || fare.supplierName === 'uapindc';

  const getBookingClassText = (bookingClass) => {
    if (!Array.isArray(bookingClass)) return '';
    return Array.isArray(bookingClass[0])
      ? bookingClass[0].join(',')
      : bookingClass.join(',');
  };

  const getFareRulesLinks = (currentFare) => (
    <>
      <AppLink
        linkText="Fare Rules"
        variant="secondary"
        className="fs-14"
        onClick={() => handleFareRulesClick(currentFare)}
      />
      {currentFare.isminifarerulesrequired === 'true' && (
        <AppLink
          linkText="Mini Fare rules"
          variant="secondary"
          className="fs-12"
          onClick={() => handleShowMiniFareRules(currentFare)}
        />
      )}
    </>
  );

  const getShareCheckbox = (currentFare) => (
    <AppCheckBox
      name="emailorwhatsapp"
      id={currentFare.nextraflightkey}
      labelText="Share via Email or WhatsApp"
      onChange={() => handleSelectForEmail(currentFare)}
      checked={isFareSelectedForEmail(currentFare)}
    />
  );

  return (
    <>
      <FareCard
        fare={fare}
        watermark={getWaterMarkForFare()}
        isSelected={fare.nextraflightkey === userSelectedFare.nextraflightkey}
        onSelect={setUserSelectedFare}
        topActions={
          <>
            {fare?.faretype_supplier?.toLowerCase() === 'ndc' && (
              <div className="fare-type-supplier">NDC Fare</div>
            )}
            {fare?.ismorefaresavailable === 'true' && (
              <AppLink
                linkText="More Fares"
                className="more-fares-link"
                onClick={handleShowBrandedFares}
              />
            )}
          </>
        }
        showInvoiceFare={showInvoiceFare}
        fareBreakup={
          <FareBreakup fare={fare} showInvoiceFare={showInvoiceFare} />
        }
        isSeriesFare={searchRequest.searchtype === 'seriesfares'}
        legacyInclusion={carrierInclusion}
        checkinFallback={
          fareTypeInclusion?.Checkin ||
          getCabinBaggage(fare?.flightBagWeight?.[0], fare?.flightBagUnit?.[0])
        }
        cabinFallback={
          fareTypeInclusion?.HandBaggage ||
          getCabinBaggage(fare?.cabinBagweight?.[0], fare?.cabinBagunit?.[0])
        }
        infoRows={[
          {
            label: 'Class',
            value: getBookingClassText(fare.bookingClass),
            className: 'class',
          },
          ...(showSupplier()
            ? [
                {
                  label: 'Supplier',
                  value: getSupplierName(fare.supplierName),
                  className: 'suppiler',
                },
              ]
            : []),
        ]}
        seatsLeftText={
          isSeatCountHidden ? '' : getSeatsLeftText(fare.numseatsavailable?.[0])
        }
        links={getFareRulesLinks(fare)}
        onBook={handleBook}
        footer={
          <>
            {getShareCheckbox(fare)}
            {fare.airFreeText?.length > 0 && (
              <div className="fs-12 green-color">
                {fare.airFreeText.join(',')}
              </div>
            )}
          </>
        }
      />
      {showBrandedfares && (
        <AppModal
          modalTitle="Branded Fares"
          showCloseButton
          size="lg"
          onModalClose={() => setShowBrandedfares(false)}
          className="branded-fares-modal"
        >
          <ResultCardFlightInfo
            flight={flight}
            isOnward
            userSelectedFare={userSelectedFare}
            isAmPmFormat={isAmPmFormat}
            searchRequest={searchRequest}
            hideLegInfo
          />
          {journeyType === 'roundtrip' &&
            domint === 'international' &&
            returnFlight && (
              <ResultCardFlightInfo
                flight={returnFlight}
                isOnward={false}
                userSelectedFare={userSelectedFare}
                isAmPmFormat={isAmPmFormat}
                searchRequest={searchRequest}
                hideLegInfo
              />
            )}
          <div className="d-flex align-items-stretch gap-2 overflow-auto mt-2 pb-2">
            {brandedFares.length > 0 ? (
              brandedFares.map((brandedFare) => (
                <FareCard
                  key={brandedFare.nextraflightkey}
                  fare={brandedFare}
                  watermark={getWaterMarkForFare()}
                  isSelected={
                    brandedFare.nextraflightkey ===
                    userSelectedFare.nextraflightkey
                  }
                  onSelect={setUserSelectedFare}
                  showInvoiceFare={showInvoiceFare}
                  fareBreakup={
                    <FareBreakup
                      fare={brandedFare}
                      showInvoiceFare={showInvoiceFare}
                      searchRequest={searchRequest}
                      isPaxWise
                    />
                  }
                  checkinFallback={getCabinBaggage(
                    brandedFare.flightBagWeight?.[0],
                    brandedFare.flightBagUnit?.[0],
                  )}
                  cabinFallback={getCabinBaggage(
                    brandedFare.cabinBagweight?.[0],
                    brandedFare.cabinBagunit?.[0],
                  )}
                  infoRows={[
                    {
                      label: 'Class',
                      value: getBookingClassText(brandedFare.bookingClass),
                    },
                    {
                      label: 'Supplier',
                      value: getSupplierName(brandedFare.supplierName),
                    },
                  ]}
                  seatsLeftText={getSeatsLeftText(
                    brandedFare.numseatsavailable?.[0],
                  )}
                  links={getFareRulesLinks(brandedFare)}
                  onBook={(selectedBrandedFare) => {
                    setShowBrandedfares(false);
                    handleBook(selectedBrandedFare);
                  }}
                  footer={getShareCheckbox(brandedFare)}
                />
              ))
            ) : (
              <div>Branded fares are not available</div>
            )}
          </div>
        </AppModal>
      )}
    </>
  );
}
